module.exports = __webpack_public_path__ + "img/logo-delivery-verde.7337d503.svg";